import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from "@angular/core";
import {
  SiteDataModel,
  CompanyLogo,
  MenuItemModel,
} from "../../../@core/models/site-material-data.model";
import { BehaviorSubject, Subscription } from "rxjs";
import { ThemeModel } from "../../../@core/models/theme.model";
import { DataService } from "../../../@core/services/data.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Meta } from "@angular/platform-browser";
import { ThemeService } from "../../../@core/services/theme.service";
import { Icons } from "../../../../assets/social-material.json";
import { SiteModel } from "../../../@core/models/builder.model";
import { SidenavService } from "../../../@core/services/sidenav.service";
import { AnalyticsService } from "../../../@core/services/analytics.service";
import * as Sentry from "@sentry/browser";
import { CognitoService } from "../../../@core/services/cognito.service";
import { UserService } from "../../../@core/services/user.service";
import { environment } from "../../../../environments/environment";
import { FontsService } from "../../../@core/services/fonts.service";
import { ScriptLoaderService } from "../../../@core/services/scripts.service";
import { isPlatformBrowser } from "@angular/common";

declare const leadifulChatWidget: any;
@Component({
  selector: "app-material-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush

})

export class MaterialHeaderComponent implements OnInit, OnDestroy {
  siteMenu$: BehaviorSubject<MenuItemModel[]> = new BehaviorSubject<MenuItemModel[]>([]);
  siteModules: string[];
  siteData: SiteDataModel;
  siteTitle: string;
  textColor: string;
  OldtextColor: string;
  backgroundColor: string;
  siteTheme: ThemeModel;
  companyName: string;
  companyLogo: CompanyLogo;
  subscription: Subscription;
  page: string = '';
  siteId: string = '';
  activatePadding: boolean = false;
  isHomePage: boolean = true;
  ecommerceExist: boolean = false;
  siteName: string = '';
  icons: string[] = Icons;
  active: boolean = false;
  innerWidth: number = 0;
  displayOpenBuilder: boolean = false;
  transparentHeader: boolean = false;
  leadifulIsopen: boolean = false;
  leadifulChat;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private analyticsService: AnalyticsService,
    private themeService: ThemeService,
    private fontsService: FontsService,
    private router: Router,
    private cognitoService: CognitoService,
    private userService: UserService,
    private sidenav: SidenavService,
    private scriptService: ScriptLoaderService,
    private metaService: Meta,
    @Inject(PLATFORM_ID) private platformId,

  ) {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "HeaderComponent");
    });
    this.page = this.router.url.split('/')[1];
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.innerWidth = window.innerWidth;
      const siteContainer = document.getElementsByClassName("site-container")[0];
      if (siteContainer) {
        siteContainer['style'].height = (siteContainer['offsetHeight'] + 10) + "px";
      }
    }
    this.active = true;
    this.subscription = this.dataService.getCurrentSite().subscribe((site: SiteModel) => {
      // Making sure data is loaded
      if (site !== null) {
        this.siteId = site.siteId;
        this.siteName = "logo " + site.siteName;
        if (this.page != "builder" && this.page != "site" && this.innerWidth > 450) {
          if (typeof Storage != "undefined") {
            if (localStorage.getItem('userData')) {
              this.displayOpenBuilder = true;
            }
          }
          this.analyticsService.getUtm();
          if (this.analyticsService.firstVisit) {
            this.analyticsService.firstVisit = false;
            this.analyticsService.getLocationInfo().then(location => {
              if (location != "-") {
                this.analyticsService.eventEmiter(site, "/", 'pageviews', 'trafic', location);
                this.analyticsService.eventEmiter(site, "/", 'pageviews', 'geo', location);
                this.analyticsService.eventEmiter(site, "/", 'pageviews', 'device', location);
                this.analyticsService.trackUserNavigation(site);
              }
            })
          }
          if (site.siteId == '149fb4dd-f453-4b0f-95fa-8832381a69f2') {
            // <meta name="facebook-domain-verification" content="rog8exzman4jabjp1vo47iewf74pvw" />
            this.metaService.updateTag({ name: 'facebook-domain-verification', content: 'rog8exzman4jabjp1vo47iewf74pvw' });
          }
          if (site.googleAnalyticsPixel) {
            this.loadGoogleAnalytics(site.googleAnalyticsPixel);
          }
          if (site.facebookPixel) {
            this.loadFacebook(site.facebookPixel);
          }
          if (site.googleTagManagerPixel) {
            this.loadGoogleTagManager(site.googleTagManagerPixel);
          }
          if (site.googleAdwordsPixel && site.googleAdwordsPixel.conversionID) {
            this.loadGoogleAds(site.googleAdwordsPixel.conversionID);
          }
        }
        this.siteTitle = site.siteName;
        this.companyName = site.siteName;
        this.companyLogo = site.companyLogo;
        // this.logo = this.companyLogo.logo;
        this.siteModules = site.modules;
        this.siteData = typeof site.siteData == 'string' ? JSON.parse(site.siteData) : site.siteData;
        this.siteTheme = this.themeService.usedTheme$.getValue()
          ? this.themeService.usedTheme$.getValue()
          : (typeof site.siteStyle == 'string' ? JSON.parse(site.siteStyle) : site.siteStyle);
        if (site.fontFamily != 'Roboto') this.fontsService.changeFont(site.fontFamily);
        if (this.page !== 'builder' && this.page !== 'site') {
          this.themeService.updateTheme(this.siteTheme);
        }
        // this.siteTheme = JSON.parse(site.siteStyle);
        // change the site title
        // this.titleService.setTitle(this.siteTitle);
        // Get menu links
        this.textColor = site && site.siteMenu && site.siteMenu.length > 0 ? site.siteMenu[0].textColor : (site.companyLogo && site.companyLogo.textColor ? site.companyLogo.textColor : '');
        this.backgroundColor = site && site.siteMenu && site.siteMenu.length > 0 ? site.siteMenu[0].backgroundColor : (site.companyLogo && site.companyLogo.backgroundColor ? site.companyLogo.backgroundColor : '');
        this.transparentHeader = site && site.siteMenu && site.siteMenu.length > 0 ? site.siteMenu[0].transparentHeader : (site.companyLogo && site.companyLogo.transparentHeader ? site.companyLogo.transparentHeader : false);
        if (this.dataService.getDefaultColor(this.textColor) === this.dataService.getDefaultColor(this.backgroundColor)) {
          if (this.router.url.includes('blog') || this.router.url.includes('blog') || this.router.url.includes('cart') || this.router.url.includes('shop') || this.router.url.includes('checkout')) {
            this.textColor = '#000';
            site.siteMenu.forEach(item => {
              item.textColor = '#000';
            });
          }
        }
        if (site.siteMenu && site.siteMenu.length > 0) {
          this.siteMenu$.next(site.siteMenu);
          this.OldtextColor = this.textColor;
        } else {
          this.getMenu();
        }
        if (this.router.url.toString().includes('blog') || this.router.url.toString().includes('cart') || this.router.url.toString().includes('shop') || this.router.url.toString().includes('checkout') || this.router.url.toString().includes('tos') || this.router.url.toString().includes('privacy-policy')) {
          this.isHomePage = false;
          if (this.siteMenu$.getValue().length > 0 && this.transparentHeader && this.siteMenu$.getValue()[0].backgroundColor.toLocaleLowerCase().includes('#fff')) {
            this.OldtextColor = this.siteMenu$.getValue()[0].textColor;
            this.textColor = '#000';
          } else {
            this.textColor = this.OldtextColor;
          }
        }
        if (this.route.snapshot.fragment) {
          if (this.route.snapshot.fragment === 'Store') {
            setTimeout(() => {
              let frag = this.route.snapshot.fragment.replace(/-/g, ' ');
              site.modules.forEach((element, index) => {
                if (element == 'Ecommerce') {
                  this.navigateTo(index.toString());
                }
              })
            }, 1000);
          } else {
            setTimeout(() => {
              let frag = this.route.snapshot.fragment.replace(/-/g, ' ');
              this.siteMenu$.getValue().forEach(element => {
                if (element.title == frag) {
                  this.navigateTo(element.link);
                }
              })
            }, 1000);
          }
        }
        let result = this.siteMenu$.getValue().map(element => {
          return { ...element, newUrl: element.title.replace(/ /g, "-") }
        });
        this.siteMenu$.next(result);
        if (site && site.modules && Array.isArray(site.modules) && site.modules.indexOf('Ecommerce') >= 0) {
          this.ecommerceExist = true;
          let result = this.siteMenu$.getValue();
          result.push({
            title: 'ecom',
            link: '/cart',
            type: 'button'
          });
          this.siteMenu$.next(result);
        }
        if (site.plugins) {
          const intercomId = site.plugins.filter(plugin => plugin.name == "intercom" && plugin.config['intercomId']);
          if (intercomId.length > 0) {
            this.loadIntercom(intercomId[0].config['intercomId']);
          }
          const facebookChat = site.plugins.filter(plugin => plugin.name == "facebookChat" && plugin.config['pageId']);
          if (facebookChat.length > 0) {
            this.loadFacebookChatPlugin(facebookChat[0].config['pageId']);
          }
          this.leadifulChat = site.plugins.filter(plugin => plugin.config['leadiful_client_id'] && plugin.config['leadiful_client_name']);
          if (this.leadifulChat.length > 0) {
            this.loadLeadifulChat();
            this.scriptService.load({ typeOfScript: 'src', name: 'leadifulchat', loaded: false, src: 'https://leadifulchat.s3.eu-west-1.amazonaws.com/chatmodulev1.min.js' }).subscribe(resp => {
              this.scriptService.load({ typeOfScript: 'script', name: 'addEventListener', loaded: false, src: `leadifulChatWidget({}, '${this.leadifulChat[0].config['leadiful_client_id']}', '${this.leadifulChat[0].config['leadiful_client_name']}')` }).subscribe(res => {
              })
            });
          }
        }
      }
    });
  }

  getMenu(): void {
    this.siteMenu$.next([]);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  toggleRightSidenav() {
    this.sidenav.toggle();
  }

  loadGoogleAnalytics(trackingID: string): void {

    const gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${trackingID}`);

    const gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;

    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }


  loadLeadifulChat(): void {
    const leadifulDiv = document.createElement('div');
    leadifulDiv.setAttribute('id', `chat-widget-container`);
    document.documentElement.appendChild(leadifulDiv);
    const leadifulLink = document.createElement('link');
    leadifulLink.setAttribute('href', `https://leadifulchat.s3-eu-west-1.amazonaws.com/css/chatmodulev1.min.css`);
    leadifulLink.setAttribute('rel', `stylesheet`);
    leadifulLink.setAttribute('type', `text/css`);
    document.documentElement.appendChild(leadifulLink);
  }
  clickLeadiful() {
    if (!this.leadifulIsopen) {
      this.leadifulIsopen = true;
      leadifulChatWidget({}, '76', 'Leadiful');
    }
  }
  loadFacebookChatPlugin(facebookChatPlugin: string): void {
    const chatboxScript = document.createElement('script');
    chatboxScript.innerText = `var chatbox = document.getElementById('fb-customer-chat');
    chatbox.setAttribute("page_id", "${facebookChatPlugin}");
    chatbox.setAttribute("attribution", "biz_inbox");`
    document.documentElement.firstChild.appendChild(chatboxScript);

    // Your SDK code

    const sdkScript = document.createElement('script');
    sdkScript.innerText = `window.fbAsyncInit = function () {
      FB.init({
        xfbml: true,
        version: 'v14.0'
      });
    };
  
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));`
    document.documentElement.firstChild.appendChild(sdkScript);
  }
  loadFacebook(trackingIDPixel: string): void {
    const fbScript = document.createElement('script');
    const fbNoScript = document.createElement('noscript');
    fbScript.innerText = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,\'script\',\'https://connect.facebook.net/en_US/fbevents.js\');fbq(\'init\', \'${trackingIDPixel}\');fbq(\'track\', \'PageView\');`;
    fbNoScript.innerText = `<img height="1" width="1" style="display:none" src="${trackingIDPixel}" />`;

    document.documentElement.firstChild.appendChild(fbScript);
    document.documentElement.firstChild.appendChild(fbNoScript);
  }

  loadGoogleTagManager(trackingID: string): void {
    const fbScript = document.createElement('script');
    fbScript.innerText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);})(window,document,\'script\',\'dataLayer\',\'${trackingID}\');`;
    document.documentElement.firstChild.appendChild(fbScript);
  }

  loadGoogleAds(trackingID: string): void {
    const gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${trackingID}`);

    const gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;

    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }

  loadIntercom(id: string): void {
    (<any>window).intercomSettings = {
      app_id: id
    };
    setTimeout(() => {
      const gaScript = document.createElement('script');
      gaScript.innerText = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/dl81to2a';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`;
      document.documentElement.firstChild.appendChild(gaScript);
    }, 1000);
  }

  openBuilder() {
    this.router.navigate(['builder']);
  }

  openSetting() {
    this.cognitoService.renewTest()
      .then((res) => {
        const newCognitoUser = this.cognitoService.userPool.getCurrentUser();
        newCognitoUser.getSession(async (err, session) => {
          if (session) {
            const sessionExpirationTimeSecs = session.accessToken.payload.exp;
            const timeNowSecs = (new Date().getTime() / 1000) + 300;
            if (!session.isValid() || sessionExpirationTimeSecs <= timeNowSecs) {
              const newSession = await this.cognitoService.renew(session.refreshToken.token);
            }
          }
        });
        const getDevice = this.cognitoService.getDevice();
        this.subscription = this.userService.getOpenToken().subscribe(data => {
          window.open(`${environment.backUrl}/open-id-connect/getToken/${data['openToken']}?redirect=settings&deviceKey=${getDevice['deviceKey']}&deviceGroupKey=${getDevice['deviceGroupKey']}`);
        });
      }, (err) => {
      });
  }
  logout() {
    this.cognitoService.signOut().then((res) => {
      // Signout was successful, redirecting to the login page
      this.displayOpenBuilder = false;
    }, (err) => {
      this.router.navigate(['/pages/error/400']);
    });
  }
  // nav 
  navigateTo(fragment: string) {
    if (fragment) {
      fragment = fragment.replace('/#', '')
      setTimeout(() => {
        if (document.getElementById(fragment)) {
          document.getElementById(fragment).scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }
  redirectFromHeader(link: string) {
    if (link) {
      window.location.href = link;
    }
    else {
      this.router.navigate(['']);
    }
  }

}
